
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class DarkModeHighlightMixin extends Vue {
  /** Get highlight color based on dark mode */
  get color() {
    return this.$vuetify.theme.dark ? "darken-4" : "lighten-4";
  }

  get colorVariantBack() {
    return this.$vuetify.theme.dark ? "darken-4" : "lighten-4";
  }

  get colorVariantTop() {
    return !this.$vuetify.theme.dark ? "darken-1" : "lighten-4";
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  /**
   * sets cards background color depending on dark mode
   */
  get backgroundColor() {
    return `background-color: ${this.$vuetify.theme.dark ? "#121212" : "#f5f5f5"};`;
  }

  /**
   * sets cards background color depending on dark mode
   */
  get invertedBackgroundColor() {
    return `background-color: ${!this.$vuetify.theme.dark ? "rgba(18, 18, 18, 1)" : "rgba(245, 245, 245, 1)"};`;
  }

  /**
   * sets cards background color depending on dark mode
   */
  get invertedBackgroundColorLight() {
    return `background-color: ${!this.$vuetify.theme.dark ? "rgba(18, 18, 18, 0.2)" : "rgba(245, 245, 245, 0.2)"};`;
  }
}
